/**
 * List-filter categories for GET /notifications/v2?category=…
 * Keep in sync with backend notification-type-config.ts
 */

export const NOTIFICATION_LIST_FILTER_CATEGORIES = [
  'messages',
  'social',
  'stories',
  'sports',
  'groups',
  'pages',
  'live',
  'system',
]

/** @type {Record<string, string[]>} */
const TYPE_TO_LIST_CATEGORIES = {
  NEW_MESSAGE: ['messages'],
  MENTION: ['messages'],
  REPLY: ['messages'],
  CONVERSATION_CREATED: ['messages'],
  USER_ADDED_TO_CONVERSATION: ['messages'],
  USER_REMOVED_FROM_CONVERSATION: ['messages'],
  REACTION_ADDED: ['messages'],
  MESSAGE_REACTION: ['messages'],
  MESSAGE: ['messages'],
  POST_LIKE: ['social'],
  COMMENT: ['social'],
  POST_SHARED: ['social'],
  POST_TAGGED: ['social'],
  COMMENT_MENTION: ['social'],
  POST_APPROVED: ['social'],
  FRIEND_REQUEST: ['social'],
  FRIEND_REQUEST_ACCEPTED: ['social'],
  POST_UPDATED: ['social'],
  BIRTHDAY_REMINDER: ['social'],
  FAMILY_REQUEST: ['social'],
  GROUP_TAGGED: ['groups', 'social'],
  PAGE_TAGGED: ['pages', 'social'],
  STORY_TAGGED: ['stories', 'social'],
  STORY_GROUP_TAGGED: ['stories', 'groups'],
  STORY_PAGE_TAGGED: ['stories', 'pages'],
  STORY_REACTION: ['stories', 'social'],
  STORY_PENDING_MODERATION: ['stories', 'system'],
  STORY_APPROVED: ['stories', 'system'],
  STORY_BANNED: ['stories', 'system'],
  GROUP_INVITE_TO_GROUP: ['groups'],
  GROUP_JOIN_REQUEST: ['groups'],
  GROUP_JOIN_REQUEST_ACCEPTED: ['groups'],
  GROUP_POST_CREATED: ['groups'],
  GROUP_MEMBER_ADDED: ['groups'],
  GROUP_MEMBER_ROLE_UPDATED: ['groups'],
  PAGE_FOLLOW: ['pages'],
  PAGE_MEMBER_ADDED: ['pages'],
  PAGE_POST_CREATED: ['pages'],
  PAGE_MEMBER_ROLE_UPDATED: ['pages'],
  PAGE_INVITE_TO_FOLLOW: ['pages'],
  PAGE_INVITE_ACCEPTED: ['pages'],
  PAGE_MEMBER_INVITE: ['pages'],
  PAGE_MEMBER_INVITE_ACCEPTED: ['pages'],
  PAGE_MEMBER_INVITE_DECLINED: ['pages'],
  USER_WENT_LIVE: ['live', 'social'],
  LIVE_TERMINATED_BY_MOD: ['live', 'system'],
  FAVORITE_TEAM_MATCH_STARTING: ['sports', 'system'],
  FAVORITE_TEAM_MATCH_STARTED: ['sports', 'system'],
  FAVORITE_TEAM_MATCH_FINISHED: ['sports', 'system'],
  FAVORITE_TEAM_SCORED: ['sports', 'system'],
  FAVORITE_TEAM_WON: ['sports', 'system'],
  FAVORITE_TEAM_LOST: ['sports', 'system'],
  FAVORITE_TEAM_DREW: ['sports', 'system'],
  FAVORITE_TEAM_MATCH_REMINDER: ['sports', 'system'],
  INVITATION: ['system'],
  BRONZE_BADGE: ['system'],
  SILVER_BADGE: ['system'],
  GOLD_BADGE: ['system'],
  VOICE_CALL: ['system'],
  VIDEO_CALL: ['system'],
  CAMPAIGN_FINISHED: ['system'],
  TASK_ASSIGNED: ['system'],
  TASK_COMPLETED: ['system'],
  TASK_REOPENED: ['system'],
  PROJECT_INVITATION: ['system'],
  TASK_UPDATED: ['system'],
  TASK_REMINDER_DAILY: ['system'],
  TASK_REMINDER_BEFORE_DEADLINE: ['system'],
  TASK_REMINDER_CUSTOM: ['system'],
  EVENT_INVITATION: ['system'],
  EVENT_CANCELLED: ['system'],
  EVENT_UPDATED: ['system'],
  EVENT_INVITATION_ACCEPTED: ['system'],
  POST_PENDING_MODERATION: ['system'],
  POST_BANNED: ['system'],
  COMMENT_PENDING_MODERATION: ['system'],
  COMMENT_APPROVED: ['system'],
  COMMENT_BANNED: ['system'],
  SYSTEM_ANNOUNCEMENT: ['system'],
  CONTEST_WINNER: ['system', 'social'],
  USER_RESTRICTED: ['system'],
  USER_UNRESTRICTED: ['system'],
  CAREERS_NEW_APPLICATION: ['system'],
  CAREERS_APPLICATION_UPDATED: ['system'],
  CAREERS_APPLICATION_WITHDRAWN: ['system'],
}

export function getListCategoriesForType(type) {
  return TYPE_TO_LIST_CATEGORIES[type] || ['system']
}

export function notificationMatchesListCategory(notification, category) {
  if (!category) return true
  if (!notification?.type) return false
  return getListCategoriesForType(notification.type).includes(category)
}

export function getGroupedNotificationBody(notification) {
  if (notification?.isGrouped && notification?.body) return notification.body
  return null
}
